export const CountryList = [
    { value: 'CF', label: 'Central African Republic' },
    { value: 'GH', label: 'Ghana' },
    { value: 'KE', label: 'Kenya' },
    { value: 'NA', label: 'Namibia' },
    { value: 'NG', label: 'Nigeria' },
]